// extracted by mini-css-extract-plugin
export var equalColumn = "_ee-0";